// extracted by mini-css-extract-plugin
export var brand = "_aw-9";
export var compact = "_aw-6";
export var extraSmall = "_aw-7";
export var icon = "_aw-0";
export var large = "_aw-4";
export var light = "_aw-1";
export var medium = "_aw-5";
export var outline = "_aw-b";
export var primaryDark = "_aw-a";
export var primaryLight = "_aw-8";
export var primaryModern = "_aw-c";
export var success = "_aw-2";
export var successSolid = "_aw-3";